<template>
    <div class="advanced-search-list">
        <div class="layout-asb-title dsp-flex">
            <div class="layout-asb-result-title">搜索结果({{searchAdvancedResultList.length}}条记录)</div>
            <div class="layout-asb-sub-title"><span>年</span><span>月</span><span>日</span><span>时</span></div>
        </div>
        <div class="layout-asb-result-list" v-show="searchAdvancedResultList.length > 0">
            <virtual-list id="AdvancedSearchResultList" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="searchAdvancedResultList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="'com-record-item-w90'" />
        </div>
    </div>
</template>

<script>
import SearchResultAItem from '../../components/search/SearchResultAItem.vue'
import { SEARCH_DOM } from '../../modules/dom';
export default {
    name: 'AdvancedSearchList',
    computed: {
        searchAdvancedResultList() {
            return this.$store.state.search.searchAdvancedResultList;
        }
    },
    data() {
        return {
            itemComponent: SearchResultAItem
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            SEARCH_DOM.updateAdvancedSearchPageStyle();
        }, 100);
    }
}
</script>